import React, { useState } from 'react'
import { Row, Col, Typography, Flex } from 'antd'
import { Breadcrumb, FilterJobDrawer, RightFindjoblayout, UnderlineDesign } from '../../components'

const { Title } = Typography
const Findpro = ({setJobId}) => {

  const [ filtershow, setFilterShow ] = useState(false)

  return (
    <div className=''>
        <Breadcrumb title='Find a Project' pageName='Find a Project' breadcrumb={[{to:'/',name:'Home'}]}/>
        <div className='padding-t'>
          <div className='container'>
            <Row gutter={[24,24]} className='mb-3' justify={'center'}>
              <Col span={24}>
                <Flex vertical align='center'>
                  <Title level={2} className='m-0 gradient-text'>Looking for a <strong className='text-brand'>Project</strong>?</Title>
                  <UnderlineDesign />
                </Flex>
              </Col>
              <Col span={24}>
                <RightFindjoblayout setJobId={setJobId} />
              </Col>
            </Row>
          </div>
        </div>
        <FilterJobDrawer 
          visible={filtershow}
          onClose={()=>setFilterShow(false)}
        />
    </div>
  )
}

export {Findpro}